export const defaultSchema = {
  scenario: [{
    name: 'defaultScenario',
    value: 'Smart Page Default Scenario',
    activity: [{
      name: 'logError',
      value: 'Smart Page Custom Error',
    }, {
      name: 'logTrace',
      value: 'Smart Page Custom Trace',
    }, {
      name: 'logMetrics',
      value: 'Smart Page Metrics',
    }],
  }],
};

export const globalErrorSchema = {
  scenario: [{
    name: 'appReactGlobalError',
    value: 'Log application global react error',
    activity: [{
      name: 'logError',
      value: 'Log Error Info',
    }],
  }],
};
